"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Option.css");
var key_press_1 = require("../../../../../utils/key-press");
var Label_1 = require("../../../Label");
var enterIsPressed = key_press_1.KeyPress.enterIsPressed;
var tabIsPressed = key_press_1.KeyPress.tabIsPressed;
var Option = /** @class */ (function (_super) {
    __extends(Option, _super);
    function Option(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { templateType: false };
        _this.setLiRef = _this.setLiRef.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.getCustomDisabledOptionStyling = _this.getCustomDisabledOptionStyling.bind(_this);
        return _this;
    }
    Option.prototype.componentDidMount = function () {
        this.setState({ templateType: React.Children.count(this.props.children) > 0 });
    };
    Option.prototype.handleClick = function () {
        this.props.onSelect(this.props.data.choice, false);
    };
    Option.prototype.handleKeyDown = function (e) {
        if (enterIsPressed(e) || tabIsPressed(e)) {
            var elem = e.target;
            elem.parentElement.parentElement.parentElement.children[0].focus();
            this.props.onSelect(this.props.data.choice, true);
        }
        else if (this.props.handelKeyDown) {
            this.props.handelKeyDown(e);
        }
    };
    Option.prototype.setLiRef = function (element) {
        this.liRef = element;
    };
    Option.prototype.getCustomDisabledOptionStyling = function (props) {
        // first check for individual disabled option styles
        // and if none exist, check for group disabled option styles
        if (this.props.data &&
            this.props.data.choice &&
            this.props.data.choice.customDisabledOptionStyles &&
            Object.keys(this.props.data.choice.customDisabledOptionStyles).length > 0) {
            return this.props.data.choice.customDisabledOptionStyles;
        }
        else if (this.props.options &&
            this.props.options.customDisabledOptionStyles &&
            Object.keys(this.props.options.customDisabledOptionStyles).length > 0) {
            return this.props.options.customDisabledOptionStyles;
        }
        else {
            return {};
        }
    };
    Option.prototype.render = function () {
        var _a = this.props.data, choice = _a.choice, isSelected = _a.isSelected;
        var isDisabled = (this.props.options && this.props.options.disabled) ? true : false;
        var isRennyStyle = this.props.options && this.props.options.isRennyStyle;
        var classes;
        if (this.props.options && this.props.options.isRedesign) {
            classes = isSelected ? [styles.menuItemRedesign, styles.menuItemSelected].join(' ') : styles.menuItemRedesign;
        }
        else if (isRennyStyle) {
            classes = isSelected ? [styles.menuItemRenny, styles.menuItemSelected].join(' ') : styles.menuItemRenny;
        }
        else {
            classes = isSelected ? [styles.menuItem, styles.menuItemSelected].join(' ') : styles.menuItem;
        }
        if (this.props.options && this.props.options.showCircle) {
            classes += " " + styles.seprater;
        }
        if (isDisabled) {
            classes += " " + styles.disabled;
        }
        var text = choice.displayText ? choice.displayText : choice.value.toString();
        var isDecodingNeeded = choice.isDecodingRequired ? choice.isDecodingRequired : false;
        var displayItem = this.state.templateType ? this.props.children : text;
        var circleText = this.props.options && this.props.options.showCircle ?
            React.createElement("div", { className: styles.radioIconButton }) : '';
        return (isDisabled ?
            (React.createElement("li", { id: this.props.testId ? this.props.testId + '_' + text : text, "data-test-id": this.props.testId, className: classes, style: this.getCustomDisabledOptionStyling(this.props) },
                circleText,
                this.state.templateType ? this.props.children : text))
            :
                (React.createElement("li", { id: this.props.testId ? this.props.testId + '_' + text : text, "data-test-id": this.props.testId, className: classes, role: "menuitem", tabIndex: 0, onClick: this.handleClick, "aria-selected": isSelected, ref: this.setLiRef, onKeyDown: this.handleKeyDown },
                    circleText,
                    this.state.templateType ? this.props.children :
                        React.createElement(Label_1.default, { data: { text: text, isDecodingRequired: isDecodingNeeded }, options: { className: isRennyStyle ? styles.rennyLabel : '' } }))));
    };
    return Option;
}(React.Component));
exports.default = Option;
//# sourceMappingURL=Option.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/Option/Option.js
// module id = 1243
// module chunks = 8